export default __webpack_public_path__ + "static/media/uploadtimesheet.6ba25f2a.svg";